<template>

  <div class="ob-content">
    <ob-filters>
      <products-filters :filters="filters" @change="changeFilters($event)"></products-filters>

      <template v-slot:controls="{ options }">
        <v-btn :depressed="!options.mobile" v-if="$can('manager')" @click="$router.push({name: 'entity/export-import', params: {entity: 'product'}})">
          <font-awesome-icon icon="exchange-alt" />
          {{ $t('export-import') }}
        </v-btn>
      </template>
    </ob-filters>

    <v-card>
      <products-table
        ref="table"
        :source="source"
        @click="$router.push({ name: 'products/id', params: { id: $event.id} })"
      />
    </v-card>

    <v-btn fab fixed bottom right color="primary" @click="$router.push({ name: 'products/new' })">
      <v-icon>add</v-icon>
    </v-btn>
  </div>
</template>

<script>
import ApiService from '../../services/api.service.es6'
import ProductsTable from './components/products-table'
import ProductsFilters from './components/products-filters'
import ObFilters from '../shared/components/filters'

export default {
  data () {
    return {
      source: args => ApiService.findAllPaginated('products', this.apiFilters, args.sort, args.pagination),
      filters: {
        category: null
      }
    }
  },

  computed: {
    apiFilters () {
      return {
        filter: [
          { name: 'products.category', value: this.filters.category }
        ]
      }
    }
  },

  methods: {
    changeFilters (filters) {
      this.filters = filters
      this.$refs.table.refresh()
    }
  },

  components: {
    ObFilters,
    ProductsFilters,
    ProductsTable
  }
}
</script>

<style scoped lang="scss">

</style>
